import { render, staticRenderFns } from "./LearnStatisticsDialog.vue?vue&type=template&id=122651aa&scoped=true&"
import script from "./LearnStatisticsDialog.vue?vue&type=script&lang=js&"
export * from "./LearnStatisticsDialog.vue?vue&type=script&lang=js&"
import style0 from "./LearnStatisticsDialog.vue?vue&type=style&index=0&id=122651aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122651aa",
  null
  
)

component.options.__file = "LearnStatisticsDialog.vue"
export default component.exports